import { jsx as _jsx } from "react/jsx-runtime";
const StatusTab = () => {
    return _jsx("div", {});
};
// What is the Device’s current situation?
// # Pre-Allocation: Manufacturer, Joined, Inventory, Rejected
// # Situation: Allocated, Commissioned, Decommissioned, Unknown, Suspended, Under Investigation, Retired, Fault Reported, With Engineering
// Where does responsibility for the Device lie currently (who has the device)?
// # With customer, with manufacturer, with engineer, in inventory?
// # Where is the device currently (free text) eg at TRistan’s for Testing
// What is the Battery status of the Device?
// # Battery capacity
// # Voltage
// # Charging
// # Battery Health (trend last 5 days) - Declining, Improving, Stable
// # Battery Decline Days
// What is the current fault status of the Device?
// # Fault present or not
// # Type of fault
// If a fault is identified, when and who was it identified by?
// # Add a support ticket number
// What Entity is the Device associated with?
// What is the outcome of the fault diagnosis?
// What is the repair outcome?
// What is the history of the fault identification, diagnosis and resolution?
// and manage fault diagnosis/ resolution process
export default StatusTab;
